import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import MobileLayout from '../MobileLayout';
import { setMobilePref } from '../useViewport';

const MobileProfile: React.FC = () => {
  const { user, logout } = useAuth();
  const initials = (user?.email || 'U')
    .split('@')[0]
    .split(/[.\-_]/)
    .map((s) => s[0]?.toUpperCase() || '')
    .join('')
    .slice(0, 2);

  return (
    <MobileLayout title="Profile">
      <div className="flex flex-col items-center gap-2 px-3 pb-4 pt-6">
        <div
          className="flex h-16 w-16 items-center justify-center rounded-full text-xl font-semibold text-white"
          style={{ backgroundColor: '#1993e5' }}
        >
          {initials}
        </div>
        <div className="text-sm font-semibold text-slate-900 dark:text-white">{user?.email}</div>
        {user?.companyId && <div className="text-xs text-slate-500 dark:text-slate-400">Company: {user.companyId}</div>}
      </div>

      <div className="mx-3 overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-700">
        <button
          type="button"
          onClick={() => { setMobilePref('desktop'); window.location.href = '/'; }}
          className="flex w-full items-center justify-between px-3 py-3 text-sm text-slate-900 active:bg-slate-50 dark:text-white dark:active:bg-slate-800"
        >
          <span>Use desktop site</span>
          <span className="text-slate-300">›</span>
        </button>
        <div className="border-t border-slate-100 dark:border-slate-800" />
        <button
          type="button"
          onClick={() => { setMobilePref('auto'); window.location.reload(); }}
          className="flex w-full items-center justify-between px-3 py-3 text-sm text-slate-900 active:bg-slate-50 dark:text-white dark:active:bg-slate-800"
        >
          <span>Reset device preference (auto)</span>
          <span className="text-slate-300">›</span>
        </button>
      </div>

      <div className="mx-3 mt-3 overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-700">
        <button
          type="button"
          onClick={logout}
          className="w-full px-3 py-3 text-left text-sm font-semibold text-red-600 active:bg-red-50 dark:text-red-400 dark:active:bg-red-900/30"
        >
          Sign out
        </button>
      </div>
    </MobileLayout>
  );
};

export default MobileProfile;
